import css from './index.module.scss';
import Progress from './components/progress';
import CalculatorInit from './components/init';
import Step1 from './components/step1';
import Step2 from './components/step2';
import Step3 from './components/step3';
import Step4 from './components/step4';
import Step5 from './components/step5';
import CalculatorResult from './components/result';
import { useGlobal } from '@/utils/useGlobal';
import { BladeCal } from '@/constants/blade';

export default function BladeCalculatorPC() {
    const { useState } = useGlobal();
    const [calcObj, setCalcObj] = useState({
        currentStep: 0,
        currentPage: BladeCal.Init,
    });
    return (
        <div className={`${css.BladeCalculator} blade-calculator`}>
            <div className="calculator-header">{![BladeCal.Init, BladeCal.Result].includes(calcObj.currentPage) && <Progress calcObj={calcObj} />}</div>
            <>
                {calcObj.currentPage === BladeCal.Init && <CalculatorInit calObj={calcObj} callBack={setCalcObj} />}
                {calcObj.currentPage === BladeCal.Step1 && <Step1 calObj={calcObj} callBack={setCalcObj} />}
                {calcObj.currentPage === BladeCal.Step2 && <Step2 calObj={calcObj} callBack={setCalcObj} />}
                {calcObj.currentPage === BladeCal.Step3 && <Step3 calObj={calcObj} callBack={setCalcObj} />}
                {calcObj.currentPage === BladeCal.Step4 && <Step4 calObj={calcObj} callBack={setCalcObj} />}
                {calcObj.currentPage === BladeCal.Step5 && <Step5 calObj={calcObj} callBack={setCalcObj} />}
                {calcObj.currentPage === BladeCal.Result && <CalculatorResult result={calcObj?.result} id={calcObj?.id} />}
            </>
        </div>
    );
}
